import { api, authHeader } from "../configs/axiosConfigs";
import { getPaymentReturnUrl } from "./paymentGateway";

const BASE = "/SLN/Customer/Balance";

const CustomerBalanceApi = {
  getBalance: async () => {
    const response = await api.request({
      url: BASE,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getTransactions: async (page = 1, pageSize = 20) => {
    const response = await api.request({
      url: `${BASE}/Transactions?page=${page}&pageSize=${pageSize}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  startTopUp: async (amount, returnUrl) => {
    const response = await api.request({
      url: `${BASE}/TopUp/Start`,
      method: "POST",
      headers: authHeader(),
      data: {
        amount,
        provider: "Mellat",
        returnUrl: returnUrl || getPaymentReturnUrl(),
      },
    });
    return response.data;
  },

  payInvoiceFromBalance: async (invoiceId) => {
    const response = await api.request({
      url: `${BASE}/PayInvoice/${invoiceId}`,
      method: "POST",
      headers: authHeader(),
    });
    return response.data;
  },
};

export default CustomerBalanceApi;
